// extracted by mini-css-extract-plugin
module.exports = {"HTML":"html-renderer_HTML__5Eai9"};